"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuelType = exports.DepreciationType = void 0;
var DepreciationType;
(function (DepreciationType) {
    DepreciationType["StraightLine"] = "StraightLine";
    DepreciationType["DoubleDecliningBalance"] = "DoubleDecliningBalance";
    DepreciationType["SumOfTheYears"] = "SumOfTheYears";
})(DepreciationType = exports.DepreciationType || (exports.DepreciationType = {}));
var FuelType;
(function (FuelType) {
    FuelType["Petrol"] = "Petrol";
    FuelType["Diesel"] = "Diesel";
    FuelType["Electric"] = "Electric";
    FuelType["CNG"] = "CNG";
    FuelType["LPG"] = "LPG";
})(FuelType = exports.FuelType || (exports.FuelType = {}));
//# sourceMappingURL=finance.js.map